module.exports = __webpack_public_path__ + "static/media/icon-ckeck-table-blue.95e88a33.svg";